module.exports = __webpack_public_path__ + "static/media/ProvenResults.47e83f20.png";